import styled from "styled-components";
import { colors } from "healthex-common/colors";
import { Text, ListContainer, ListRow } from "./HXMobilePage.styles";
export const ListBulletContainer = styled(ListContainer) `
    gap: 4px;
`;
export const ListBulletRow = styled(ListRow) `
    align-items: center;
    gap: 0;
`;
export const ListBullet = styled(Text) `
    color: ${(props) => `${props.color ? `${props.color}` : `${colors.accents_sunset}`}`};
    width: 24px;
    min-width: 24px;
    text-align: center;
    align-self: ${(props) => `${props.alignStart ? "flex-start" : "center"}`};
`;
